var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region-label"},[_c('div',{staticClass:"region-label_city",on:{"click":_vm.showRegionSelect}},[_vm._v("\n    "+_vm._s(_vm.curRegionName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }